import { useEffect, useState } from 'react'
import type { Documento } from '@services/db.js'
import { readDocumentBlob } from '@services/documentStorage.js'

type DocPreviewSource = Pick<Documento, 'id' | 'hasArquivo' | 'arquivoBackend' | 'tipo'>

export function useDocumentPreviewUrl(doc: DocPreviewSource | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!doc?.hasArquivo || doc.id == null) {
      setUrl(null)
      return
    }

    let cancelled = false
    let objectUrl: string | null = null

    void (async () => {
      const blob = await readDocumentBlob(doc.id!, doc.arquivoBackend)
      if (cancelled || !blob) {
        if (!cancelled) setUrl(null)
        return
      }
      objectUrl = URL.createObjectURL(blob)
      setUrl(objectUrl)
    })()

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [doc?.id, doc?.hasArquivo, doc?.arquivoBackend])

  return url
}
